import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { addToCart } from "../../../../store/order";
import { graphql, navigate, useStaticQuery } from "gatsby";
import OrderInTheNext from "../../../ecommerce/OrderInTheNext";
import { getPriceToShow } from "../../../../utils/currency";
import ecommerceApi from "../../../../services/ecommerceApi";
import EcommerceApi from "../../../../services/ecommerceApi";
import { getProductImage } from "../../../../utils/image";
import Button from "../../../shared/Button";
export interface ProductSelectorProps {
    defaultProduct: ProductType;
    slug: string;
}
import {
    ProductCategoryType,
    ProductDataType,
    ProductTaxCodeType,
    ProductType
} from "../../../../types";
export default function ProductSelector({ defaultProduct, slug }: ProductSelectorProps) {
    const dispatch = useDispatch<AppDispatch>();

    const order = useSelector((state: RootState) => state.order.order);
    const currencyCode = useSelector(
        (state: RootState) => state.currencyCode.selectedCurrencyCode?.currencyCode
    );
    const [quantity, setQuantity] = React.useState(1);

    const [selectedProductData, setSelectedProductData] = React.useState<ProductDataType | null>(
        null
    );
    const [adding, setAdding] = React.useState(false);
    const [buyNowing, setBuyNowing] = React.useState(false);

    let productImage = defaultProduct?.imageUrl
        ? {
              url: getProductImage(defaultProduct)
          }
        : null;

    if (defaultProduct && !productImage) {
        productImage = defaultProduct.assets ? defaultProduct.assets[0] : null;
    }

    const [imagePreview, setImagePreview] = React.useState<Partial<
        ProductType["assets"][0]
    > | null>(productImage);

    const handleAddToCartClick = async () => {
        setAdding(true);
        const orderId = order ? order.id : null;
        const params = {
            orderId: orderId,
            skuId: defaultProduct.id,
            quantity: 1,
            salesChannel
        };
        await dispatch(addToCart(params));
        setAdding(false);
    };

    const handleBuyNowClick = async () => {
        setBuyNowing(true);
        const orderId = order ? order.id : null;
        const params = {
            orderId: orderId,
            skuId: defaultProduct.id,
            quantity: 1,
            salesChannel
        };
        await dispatch(addToCart(params));
        navigate("/cart");
    };

    const data = useStaticQuery(graphql`
        query {
            salesChannel {
                id
                name
                email
                logo
                phone
                address
                metadata
                type
            }
        }
    `);

    const { salesChannel } = data;

    let priceToShow = getPriceToShow(
        defaultProduct.currentPrice,
        salesChannel,
        currencyCode,
        undefined,
        undefined,
        true,
        0
    );
    return (
        <>
            <div className="py-6" dangerouslySetInnerHTML={{ __html: priceToShow }}></div>
            <Button
                className="w-1/2 mx-2"
                padding="py-2 px-2"
                onClick={handleAddToCartClick}
                disabled={adding}
                loader={adding}
            >
                Buy Now
            </Button>
        </>
    );
}
